module.exports = __webpack_public_path__ + "media/images/background_01-bd562409f58f30d4ed08b591bec50cc4.jpg";